/**
 * ═══════════════════════════════════════════════════════════════
 * ECS CART COUNTER
 * ---------------------------------------------------------------
 * Actualiza en tiempo real el contador de ítems que aparece
 * en el ícono del carrito en el header.
 *
 * Escucha eventos de Rebuy Smart Cart y también consulta
 * directamente /cart.js para mantenerse sincronizado.
 *
 * Elementos que actualiza (definidos en cart-icon-bubble.liquid):
 *   #ecs-cart-count-number  → el número visible
 *   #ecs-cart-count-bubble  → el contenedor (se oculta si cart = 0)
 * ═══════════════════════════════════════════════════════════════
 */

(function () {

  // Actualiza el número y la visibilidad de la burbuja del contador
  function actualizarContador(count) {
    var bubble = document.getElementById('ecs-cart-count-bubble');
    var numero = document.getElementById('ecs-cart-count-number');

    if (!bubble || !numero) return;

    if (count > 0) {
      numero.textContent = count;
      bubble.style.display = '';
    } else {
      numero.textContent = '0';
      bubble.style.display = 'none';
    }
  }

  // Consulta el carrito de Shopify y actualiza el contador
  function sincronizarContador() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        actualizarContador(cart.item_count || 0);
      })
      .catch(function (err) {
        console.error('[ECS Counter] Error al leer el carrito:', err);
      });
  }

  // Escuchar eventos de Rebuy que indican cambios en el carrito
  document.addEventListener('rebuy:cart:change',  function () { setTimeout(sincronizarContador, 400); });
  document.addEventListener('rebuy:cart:ready',   function () { setTimeout(sincronizarContador, 300); });
  document.addEventListener('rebuy:cart:refresh', function () { setTimeout(sincronizarContador, 400); });

  // Escuchar el evento nativo de Shopify también (por si acaso)
  document.addEventListener('cart:refresh', function () { setTimeout(sincronizarContador, 400); });

  // Sincronizar al cargar la página
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sincronizarContador);
  } else {
    sincronizarContador();
  }

})();